import React, { useState } from 'react'
import icons from '../../../../../assets/icons'

const FirstRowCell = (props) => {
  const [sort, setSort] = useState(true)
    const id = props.haveSort || props.columnId
  return (
    <div style={props.style} key={props.title + new Date()} id={'column_' + id} className={`row__cell ${props.class}`}
         onClick={(e) => {
           if (props.haveSort) {
             props.onClick()
           }
           setSort(!sort)
         }}>
      <div>
        {props.title}
        {props.haveSort ? <div className={'cell__arrow up'}>
            <img src={icons.arrowDown} alt={'open'} style={{ transform: `rotate(${sort ? '180deg' : ''})` }}
                 className='fas fa-sort-down' />
          </div>
          : ''}

      </div>

    </div>)
}

export default FirstRowCell
